import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {Location, PopStateEvent} from '@angular/common';
import 'rxjs/add/operator/filter';
import PerfectScrollbar from 'perfect-scrollbar';
import {NavbarComponent} from "./shared/navbar/navbar.component";
import {UtilConfig} from "../autenticacion/servicios/UtilConfig";
import {MenuBackColor} from "./content/seguridad/emisor/recursos/modelo/MenuBackColor";
import {MenuSelectorColor} from "./content/seguridad/emisor/recursos/modelo/MenuSelectorColor";
import {WebServices} from "./recursos/modelo/consumerModel/web-services.enum";
import {ConsumerService} from "./recursos/servicio/consumer.service";
import {LayoutService} from 'app/layout/recursos/servicio/layout.service';
import {BillingConfiguration} from "./content/seguridad/emisor/recursos/modelo/emisor-configuration";

declare const $: any;

@Component({
    selector: 'app-layout',
    moduleId: module.id,
    template: `
        <app-loading *ngIf="loadingBackground"></app-loading>
        <div class="wrapper">
            <div id="sidebar" class="sidebar" data-active-color="white" data-background-color="black"
                 data-image="../assets/img/sidebar-1.jpg">
                <app-sidebar-cmp></app-sidebar-cmp>
                <div class="sidebar-background" style="background-image: url(assets/img/sidebar-1.jpg)"></div>
            </div>
            <div class="main-panel" style="overflow-x: hidden">

                <app-navbar-cmp></app-navbar-cmp>
                <div class="main-content">
                    <router-outlet name="second"></router-outlet>
                </div>
                <!--footer-cmp></footer-cmp-->
            </div>
        </div>
        <div (click)="backgroundDiv = false" *ngIf="backgroundDiv" class="publicity">
            <img [src]="background">
        </div>
    `
})


export class LayoutComponent implements OnInit, AfterViewInit {
    usuarioSession;
    url: string;
    location: Location;
    loadingBackground = true;
    backgroundDiv = false;
    background = null;
    @ViewChild('sidebar') sidebar: any;
    @ViewChild(NavbarComponent) navbar: NavbarComponent;
    private _router: Subscription;
    private lastPoppedUrl: string;
    private yScrollStack: number[] = [];

    constructor(private router: Router,
                private consumer: ConsumerService,
                private layoutService: LayoutService,
                private util: UtilConfig,
                location: Location) {


        this.location = location;
        this.usuarioSession = this.util.getCurrentUser();
        this.getItems();
        // this.getSeries();
        // this.getReceptores();
    }


    ngOnInit() {
        this.getBackgroundHome();
        this.getPublicity();

        let $sidebar = $("#sidebar");
        if (this.usuarioSession.customer.menuBackColor == MenuBackColor.OSCURO) {
            $sidebar.attr('data-background-color', "black");
        } else {
            $sidebar.attr('data-background-color', "white");
        }

        if (this.usuarioSession.customer.menuSelectorColor == MenuSelectorColor.BLANCO) {
            $("#sidebar").attr('data-active-color', "white");
        } else if (this.usuarioSession.customer.menuSelectorColor == MenuSelectorColor.AZUL) {
            $("#sidebar").attr('data-active-color', "blue");
        } else if (this.usuarioSession.customer.menuSelectorColor == MenuSelectorColor.VERDE) {
            $("#sidebar").attr('data-active-color', "green");
        } else if (this.usuarioSession.customer.menuSelectorColor == MenuSelectorColor.ROJO) {
            $("#sidebar").attr('data-active-color', "red");
        } else if (this.usuarioSession.customer.menuSelectorColor == MenuSelectorColor.AMARILLO) {
            $("#sidebar").attr('data-active-color', "orange");
        }

        const $sidebar_img_container = $sidebar.find('.sidebar-background');

        switch (this.usuarioSession.customer.menuBackgroundImage) {
            case 0:
                $sidebar_img_container.fadeOut('fast', function () {
                    $sidebar_img_container.css('background-image', 'url("assets/img/sidebar-1.jpg")');
                    $sidebar_img_container.fadeIn('fast');
                });
                break;
            case 1:
                $sidebar_img_container.fadeOut('fast', function () {
                    $sidebar_img_container.css('background-image', 'url("assets/img/sidebar-2.jpg")');
                    $sidebar_img_container.fadeIn('fast');
                });
                break;
            case 2:
                $sidebar_img_container.fadeOut('fast', function () {
                    $sidebar_img_container.css('background-image', 'url("assets/img/sidebar-3.jpg")');
                    $sidebar_img_container.fadeIn('fast');
                });
                break;
            case 3:
                $sidebar_img_container.fadeOut('fast', function () {
                    $sidebar_img_container.css('background-image', 'url("assets/img/sidebar-4.jpg")');
                    $sidebar_img_container.fadeIn('fast');
                });
                break;
        }
        const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
        const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
        this.location.subscribe((ev: PopStateEvent) => {
            this.lastPoppedUrl = ev.url;
        });
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationStart) {
                if (event.url != this.lastPoppedUrl)
                    this.yScrollStack.push(window.scrollY);
            } else if (event instanceof NavigationEnd) {
                if (event.url == this.lastPoppedUrl) {
                    this.lastPoppedUrl = undefined;
                    window.scrollTo(0, this.yScrollStack.pop());
                } else
                    window.scrollTo(0, 0);
            }
        });
        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            elemMainPanel.scrollTop = 0;
            elemSidebar.scrollTop = 0;
        });
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            let ps = new PerfectScrollbar(elemMainPanel);
            ps = new PerfectScrollbar(elemSidebar);
        }
        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            this.navbar.sidebarClose();
        });

    }


    private getBackgroundHome() {
        this.consumer.getParam(WebServices.URL_BACKGROUND_HOME, document.location.host.split(":")[0]).subscribe((response: any) => {
            let element = document.getElementsByTagName('body')[0];
            if (response.codigo === 1 && response.background) {
                element.style.backgroundImage = 'url(data:image/jpeg;base64,' + response.background + ')';
            }
            if (response.colorIcons && response.colorIcons.trim() != '') {
                this.util.setColorIcons(response.colorIcons);
                this.layoutService.actualizarColorIcons();
            }
            if (response.colorTitles && response.colorTitles.trim() != '') {
                this.util.setColorTitle(response.colorTitles);
                this.layoutService.actualizarColorTitle();

            }
            if (response.colorText && response.colorText.trim() != '') {
                this.util.setColorText(response.colorText);
                this.layoutService.actualizarColorText();
            }
            this.loadingBackground = false;
        }, error => this.loadingBackground = false);
    }

    private getPublicity() {
        this.consumer.getParam(WebServices.URL_BACKGROUND_PUBLICITY, document.location.host.split(":")[0]).subscribe((response: any) => {
            let element = document.getElementsByTagName('body')[0];
            if (response.codigo === 1 && response.publicity) {
                this.backgroundDiv = true;
                this.background = 'data:image/jpeg;base64,' + response.publicity;
            }
        });
    }

    ngAfterViewInit() {
        this.runOnRouteChange();
    }

    runOnRouteChange(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
            let ps = new PerfectScrollbar(elemMainPanel);
            ps = new PerfectScrollbar(elemSidebar);
            ps.update();
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }


    getSeries() {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.consumer.update(WebServices.URL_GET_SERIES, body).subscribe(x => {
            let emisorConfig: BillingConfiguration[] = x['billingConfigurationsList'];
            if (emisorConfig != null && emisorConfig.length > 0) {
                this.util.setSerieEmisor(emisorConfig);
            }
        }, err => {
        });
    }

    getReceptores() {
        this.consumer.search<any>('', 'ACTIVO', WebServices.URL_GET_RECEPTORES)
            .subscribe(result => {
                if (result['codigo'] === 1) {
                    this.util.setReceptores(result['receivers']);
                }
            }, err => {
            });

    }

    getItems() {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.consumer.post<any>(WebServices.URL_GET_ITEMS, body)
            .subscribe(result => {
                const productos: any = result['productsStocks'];
                if (productos != null && productos.length > 0) {
                    this.util.setProductList(productos);
                }
            }, err => {
            });

    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/layout.component.ts